import * as React from 'react';
import {FunctionComponent} from 'react';
import {classNames} from '../../Support/classNames';

interface OwnProps {
    large?: boolean;
    className?: string;
}

export const ErrorPlaceholder: FunctionComponent<OwnProps> = ({large, className}) => {
    return (
        <div className={classNames('error', {'error--large': large}, className)}>
            <div className="row">
                <div className="col-12 text-center">
                    <h3>Error</h3>
                    <p>
                        Something went wrong while loading this page. We are notified about this issue, if the error
                        persists please contact <a href="mailto:info@rp3rowing.com">info@rp3rowing.com</a>.
                    </p>
                    <button className="btn btn-primary" onClick={() => window.location.reload()}>
                        Reload
                    </button>
                </div>
            </div>
        </div>
    );
};
